<template>
  <div class="">
    <CCard class="auction-manager-card">
      <CCardHeader>
        <div class="auction-manager-card__header">
          <div class="header-container">
            <div class="btn btn-outline-dark btn-lg cursor-pointer">
              <div
                class="handler"
                tabindex="0"
                @click="$refs.fileInput.click()"
              >
                <input
                  ref="fileInput"
                  accept=".csv, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  type="file"
                  autocomplete="off"
                  tabindex="-1"
                  style="display: none"
                  multiple
                  name="csvUpload"
                  @input="fileInputFun"
                  :disabled="isSendingData"
                />
                <span>Import</span>
              </div>
            </div>
            <div v-if="tableData.length > 0">
              <button
                type="button"
                class="btn btn-primary btn-lg submit d-block"
                @click="sendingData"
                :disabled="isSendingData"
              >
                <CSpinner
                  v-if="isSendingData"
                  size="1.5"
                  color="white"
                  class="mr-3 button-spiner"
                />
                <span>Upload</span>
              </button>
            </div>
          </div>
        </div>
      </CCardHeader>
      <CCardBody color="white" border-color="white">
        <CDataTable
          class="auction-manager__table"
          :items="tableData"
          :fields="fields"
          :loading="isSendingData"
          ref="table"
        >
          <template #no-items-view>
            <div class=" my-5">
              <h5>
                Please import a CSV file by clicking <q>Import</q> button
                located at the top right corner of the page.
              </h5>
            </div>
          </template>
          <template #rowId="{item}">
            <td :data-row-id="item.id"></td>
          </template>

          <template #car="{item}">
            <td>
              <VCarCard class="auction-manager__car" :car="item.car" />
            </td>
          </template>
          <template #seller_url="{item}">
            <td>
              <span>{{ item.seller_url }}</span>
            </td>
          </template>
          <template #price="{item}">
            <td>
              <span>${{ item.price }}</span>
            </td>
          </template>
          <template #link="{item}">
            <td>
              <a
                :class="{ 'auction-manager__disabled-link': !item.link }"
                :href="item.link"
                target="blank"
              >
                Link
              </a>
            </td>
          </template>
          <template #status="{item}">
            <td class="auction-status">
              <CBadge :color="getColor(item.status)">{{ item.status }}</CBadge>
            </td>
          </template>
          <template #comments="{item}">
            <td
              class="comments"
              :class="item.comments && item.comments.length > 0 ? 'has-comments' : ''"
            >
              <a
                @click="openComments(item)"
                class="cursor-pointer"
                v-if="item.comments && item.comments.length > 0"
                >View Comments</a
              >
              <span v-else>No Comment</span>
            </td>
          </template>
          <template #edit-header> </template>
          <template #edit="{item}">
            <td>
              <CDropdown>
                <template #toggler>
                  <CButton class="toggler">
                    <CIcon name="dots" />
                  </CButton>
                </template>
                <CDropdownItem class="btn btn-info" @click="editItem(item)">
                  Edit
                </CDropdownItem>
                <CDropdownItem class="btn btn-info" @click="onDeleteItem(item)">
                  Delete
                </CDropdownItem>
              </CDropdown>
            </td>
          </template>

          <template #username="{item}">
            <td class="username">
              <a :href="getUserLink(item.username)" target="_blank">{{
                item.username
              }}</a>
            </td>
          </template>

          <template #verifiedBy="{item}">
            <td class="auction-verified">
              {{ item.verifiedBy }}
            </td>
          </template>

          <template #featured="{item}">
            <td class="featured-status">
              <!-- <input type="checkbox"
            class=""
              size="lg"
              custom
              :name="item.id"
              :id="item.id"
              :checked="item.featured === 1 ? true : false"
              :disabled="item.status === 'In Progress' ? false: true"
              @change="onChangeCheckBoxInput"
            /> -->
              <CInputCheckbox
                class=""
                size="lg"
                custom
                :name="item.id"
                :id="item.id"
                :checked="item.featured === 1 ? true : false"
                :disabled="item.status === 'In Progress' ? false : true"
                @change="onChangeCheckBoxInput"
              />
            </td>
          </template>
          <template #isTestMode="{item}">
            <td class="featured-status">
              <CInputCheckbox
                class=""
                size="lg"
                custom
                :name="item.id"
                :id="item.id"
                :checked="item.isTestMode === 1 ? true : false"
                @change="onChangeTestCheckBoxInput"
              />
            </td>
          </template>
        </CDataTable>
      </CCardBody>
      <CCardFooter class="auction-manager-card__footer">
        <!-- <VAuctionManagerPagination
          class="auction-manager-card__footer-pagination"
          :current-page.sync="currentPage"
        /> -->
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
import {
  createMarketplaceMixin,
  marketplaceStore
} from "@/mixins/marketplaceMixin";
import ModalType from "@/utils/dictionaries/modalType";
import * as XLSX from "xlsx";
import Papa from "papaparse";

export default {
  name: "GoogleDrive",
  mixins: [createMarketplaceMixin()],

  data: () => {
    return {
      isSendingData: false,
      tableData: [],
      fields: [
        {
          key: "id",
          label: "ID",
          _classes: "username",
          _style: "min-width: 125px;max-width: 125px"
        },
        {
          key: "title",
          label: "Title",
          _style: "min-width: auto;max-width: 100px"
        },
        {
          key: "year",
          label: "Year",
          _classes: "auction-verified",
          _style: "min-width: 120px;max-width: 140px"
        },
        {
          key: "city",
          label: "City",
          _style: "min-width: 140px;max-width: 140px;text-align: center;"
        },
        {
          key: "state",
          label: "State"
        },
        {
          key: "address",
          label: "Address",
          _classes: "auction-kind",
          _style: "min-width: 125px;max-width: 125px;text-align: center;"
        },
        {
          key: "miles_formatted",
          label: "Miles",
          _classes: "auction-bid",
          _style: "min-width: auto;max-width: 70px;text-align: center;"
        },
        {
          key: "price",
          label: "Price",
          _style: "min-width: 62px;max-width: 62px"
        },
        {
          key: "url",
          label: "Ad URL",
          _style: "min-width: 125px;max-width: 62px"
        },
        {
          key: "image",
          label: "Image",
          _style: "min-width: 125px;max-width: 62px"
        },
        {
          key: "seller_name",
          label: "Seller Name",
          _style: "min-width: 125px;max-width: 62px"
        },
        {
          key: "seller_url",
          label: "Seller URL",
          _style: "min-width: 125px;max-width: 62px"
        }
      ],
      loading: false
    };
  },
  methods: {
    async sendingData() {
      this.isSendingData = true;
      try {
        let res = await this[marketplaceStore.actionTypes.POST_DATA]({
          data: this.tableData
        });
        this.tableData = [];

        this.$modals.open(ModalType.DefaultModal, {
          title: "Congratulation!",
          body: `Data has been uploaded successfully!`
        });

        setTimeout(() => {
          this.$modals.close(ModalType.DefaultModal);
        }, 3000);
        this.isSendingData = false;
      } catch (err) {
        this.isSendingData = false;
        console.log("error in sending data", err);
      }
    },
    async fileInputFun(event) {
      const input = event.target;
      if (!input.files.length) {
        console.log("No file selected!");
        return;
      }

      const file = input.files[0];
      const reader = new FileReader();
      if (file.type === "text/csv" || file.type === ".csv") {
        // reader.onload = async e => {
        //   const text = e.target.result;
        //   try {
        //     let data = await this.parseCSV(text);
        //     console.log("data", data);
        //     this.tableData = data;
        //     // console.log("CSV Data:", this.tableData);
        //   } catch (err) {
        //     alert("File is Corrupted or invalid format");
        //   }
        // };
        // reader.onerror = function() {
        //   console.error("Error reading the file");
        // };

        // reader.readAsText(file);
        await this.parseCSV(file);
      } else {
        reader.onload = e => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // Convert sheet to JSON but retain the array structure for headers
            const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            if (rawData.length > 0) {
              const headers = rawData[0].map(header => {
                let normalizedHeader = header
                  .toString()
                  .toLowerCase()
                  .replace(/\s+/g, "_")
                  .replace(/\$/g, "");

                if (normalizedHeader === "vehicle_year") {
                  normalizedHeader = "year";
                }

                if (normalizedHeader === "odometer_data") {
                  normalizedHeader = "miles_formatted";
                }

                return normalizedHeader;
              });
              const dataWithObjects = rawData.slice(1).map(row => {
                let obj = {};
                row.forEach((cell, index) => {
                  obj[headers[index]] = cell;
                });
                return obj;
              });
              this.tableData = [...dataWithObjects];
            } else {
              this.tableData = [];
            }

            console.log("Excel Data:", this.tableData);
          } catch (err) {
            console.error("Error reading the Excel file", err);
            alert("File is corrupted or an invalid format");
          }
        };

        reader.onerror = function() {
          console.error("Error reading the file");
        };

        reader.readAsArrayBuffer(file);
      }

      this.$refs.fileInput.value = "";
    },
    parseCSV(file) {
      Papa.parse(file, {
        header: true,
        transformHeader: header => {
          let transformedHeader = header
          .replace(/^"|"$/g, "")
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "_")
          .replace(/[()]/g, "")

          if (transformedHeader.includes("vehicle_")) {
            transformedHeader = transformedHeader.replace("vehicle_", "");
          } else if (transformedHeader.includes("formatted_")) {
            transformedHeader = transformedHeader.replace("formatted_", "");
          }else if (transformedHeader.includes("images_url")) {
            transformedHeader = transformedHeader.replace("images_url", "image");
          }
          else if (transformedHeader.includes("odometer_data")) {
            transformedHeader = transformedHeader.replace("odometer_data", "miles_formatted");
          }
          else if (transformedHeader == 'images_url') {
            transformedHeader = transformedHeader.replace("images_url", "image");
          }

          return transformedHeader;
        },
        transform: value => {
          if (typeof value === "string") {
            return value.replace(/\$/g, "");
          }
          return value;
        },

        complete: results => {
          console.log("Parsed Data:", results.data);
          this.tableData = results.data;
        }
      });
      // try {
      //   const lines = text.split("\n").filter(line => line.trim()); // Avoid processing empty lines
      //   const headers = lines[0].split(",").map(header =>
      //     header
      //       .replace(/^"|"$/g, "")
      //       .trim()
      //       .toLowerCase()
      //       .replace(/\s+/g, "_")
      //       .replace(/[()]/g, "")
      //   );

      //   return lines.slice(1).map(line => {
      //     const regex = /(?:^|,)(?:"([^"]*(?:""[^"]*)*)"|([^",]*))/g;
      //     let match;
      //     const values = [];

      //     while ((match = regex.exec(line))) {
      //       values.push(
      //         (match[1] ? match[1].replace(/""/g, '"') : match[2]).trim()
      //       );
      //     }

      //     if (values.length !== headers.length) {
      //       throw new Error(`Mismatched number of fields on line: ${line}`);
      //     }

      //     return headers.reduce((obj, header, index) => {
      //       obj[header] = values[index];
      //       return obj;
      //     }, {});
      //   });
      // } catch (err) {
      //   console.error("Error in parsing CSV file", err);
      //   throw err; // Rethrow to handle the error outside this function
      // }
    }
  }
};
</script>
<style>
.header-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
</style>
